<p class="basin-color-mid-gray basin-font-size-14 basin-mb-2"
  [ngClass]="{'basin-display-none': (selectedStudyArea$ | async)?.global}">Upload DEM File</p>
<form [formGroup]="demFileForm"
  [ngClass]="{'basin-display-none': (selectedStudyArea$ | async)?.global || uploadedTerrainFileName !== ''}">
  <formly-form [form]="demFileForm" [fields]="demFileFields" [model]="demFileModel"></formly-form>
</form>
<div *ngIf="uploadedTerrainFileName !== ''"
  class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100 basin-mb-3">
  <div class="basin-display-flex basin-flex-row basin-gap-1 basin-align-items-center basin-justify-content-start">
    <basin-boolean-icon *ngIf="(terrainLoadingStatus$ | async) === TerrainLoadingStatus.Done" [value]="true"
      icon="symbol-check-circle symbol-outlined" color="gradient-green" class="nonInteractive"></basin-boolean-icon>
    <basin-boolean-icon
      *ngIf="(terrainLoadingStatus$ | async) === TerrainLoadingStatus.FailedOnUpload || (terrainLoadingStatus$ | async) === TerrainLoadingStatus.FailedOnDownload || (terrainLoadingStatus$ | async) === TerrainLoadingStatus.FailedOnCheckingStatus"
      [value]="true" icon="symbol-error symbol-outlined" color="red" class="nonInteractive"></basin-boolean-icon>
    <div
      *ngIf="(terrainLoadingStatus$ | async) === TerrainLoadingStatus.Uploading || (terrainLoadingStatus$ | async) === TerrainLoadingStatus.Downloading || (terrainLoadingStatus$ | async) === TerrainLoadingStatus.Calculating"
      class="basin-display-flex basin-justify-content-center basin-align-items-center lottie-container">
      <basin-lottie-animation-player [height]="'55px'" [width]="'55px'" [path]="'/assets/fileLoadingIcon.json'"
        [autoplay]="true" [loop]="true"></basin-lottie-animation-player>
    </div>
    <p>{{uploadedTerrainFileName}}</p>
  </div>
  <p-button icon="symbol-delete" styleClass="p-button-text basin-p-0 basin-width-min-content" (click)="removeDemFile()"
    (keydown.enter)="removeDemFile()"
    [disabled]="(terrainLoadingStatus$ | async) === TerrainLoadingStatus.Uploading || (terrainLoadingStatus$ | async) === TerrainLoadingStatus.Downloading || (terrainLoadingStatus$ | async) === TerrainLoadingStatus.Calculating">
  </p-button>
</div>


<div *ngIf="(terrainLoaded$ | async)">
  <p class="basin-color-mid-gray basin-font-size-14 basin-mb-2">Upload Shapefile</p>
  <form [formGroup]="shapefileForm" [ngClass]="{'basin-display-none': (scenarios$ | async)?.length !== 0}">
    <formly-form [form]="shapefileForm" [fields]="shapefileFormFields" [model]="shapefileFormModel"></formly-form>
  </form>
  <div *ngIf="(scenarios$ | async)?.length !== 0"
    class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100 basin-mb-3">
    <div class="basin-display-flex basin-flex-row basin-gap-1 basin-align-items-center basin-justify-content-start">
      <basin-boolean-icon [value]="true" icon="symbol-check-circle symbol-outlined" color="gradient-green"
        class="nonInteractive"></basin-boolean-icon>
      <p>{{uploadedFishnetShapeFileName}}</p>
    </div>
    <p-button icon="symbol-delete" styleClass="p-button-text basin-p-0 basin-width-min-content"
      (click)="scenarioModeReset()" (keydown.enter)="scenarioModeReset()">
    </p-button>
  </div>
  <div *ngIf="shapeFiles.length !== 0" id="shapefilesList"
    class="basin-display-flex basin-flex-column basin-align-items-center basin-gap-2 basin-mb-3 basin-overflow-scroll">
    <div *ngFor="let shapeFile of reversedShapeFiles()"
      class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100">
      <div
        class="basin-display-flex basin-flex-row basin-align-items-center basin-justify-content-start basin-width-93">
        <p-checkbox ariaLabel="Toggle visibility" [name]="shapeFile.name" [(ngModel)]="shapeFile.visible"
          [binary]="true" (onChange)="updateShapeFiles()" class="basin-mr-2">
        </p-checkbox>
        <basin-boolean-icon [value]="true" icon="symbol-check-circle symbol-outlined" color="gradient-green"
          class="nonInteractive basin-mr-1"></basin-boolean-icon>
        <p class="basin-white-space-nowrap basin-overflow-hidden shapefile-name">
          {{shapeFile.name}}
        </p>
      </div>
      <p-button icon="symbol-delete" styleClass="p-button-text basin-p-0 basin-width-min-content"
        (click)="removeShapeFile(shapeFile)" (keydown.enter)="removeShapeFile(shapeFile)">
      </p-button>
    </div>
  </div>
</div>

<div *ngIf="(scenarios$ | async)?.length ?? 0 > 0">
  <div
    class="basin-background-web-gray basin-width-100 basin-display-flex basin-flex-column basin-gap-1 basin-py-1 basin-px-3 basin-border-radius-4 basin-mb-3">
    <div
      class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100">
      <p class="basin-font-size-14 basin-color-primary-black">Scenarios</p>
      <p class="basin-font-size-14 basin-color-primary-black">{{ (scenarios$ | async)?.length }}</p>
    </div>
    <div
      class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100">
      <p class="basin-font-size-14 basin-color-primary-black">Landslides</p>
      <p class="basin-font-size-14 basin-color-primary-black">{{ numLandslides }}</p>
    </div>
  </div>

  <formly-form [form]="scenariosForm" [fields]="scenariosFormFields" [model]="scenariosFormModel"></formly-form>
</div>

<div class="basin-width-100 basin-display-flex basin-justify-content-end">
  <p-button type="submit" *ngIf="terrainLoaded$ | async" (click)="placeAgents()" (keydown.enter)="placeAgents()"
    [disabled]="(selectedSimulationId$ | async) === null || ((scenarios$ | async)?.length === 0 && shapeFiles.length === 0) || isAddAgentsCompleted"
    [title]="(scenarios$ | async)?.length ?? 0 > 0 ? 'Place Scenarios' : 'Place Agents'"
    [label]="(scenarios$ | async)?.length ?? 0 > 0 ? 'Place Scenarios' : 'Place Agents'"></p-button>
</div>